// 韓国語の表（鍵は日本語の文言そのまま。足りない鍵は tools/devtest/i18n_keys.py で分かる）。
// パラメータの名前は仮（用語を決めたら直す）。
export const ko: Record<string, string> = {
  "歌のトラック": "보컬 트랙",
  "音符を描いて歌わせる": "음표를 그려서 노래하게 하기",
  "伴奏のトラック": "반주 트랙",
  "音声ファイルを選択（画面にドロップしても追加できます）": "오디오 파일 선택 (화면에 끌어다 놓아도 추가 가능)",
  "ドロップすると伴奏トラックとして追加します": "놓으면 반주 트랙으로 추가됩니다",
  "音声ファイル（wav・mp3・flac など）をドロップしてください": "오디오 파일(wav, mp3, flac 등)을 끌어다 놓으세요",
  "名前を変える": "이름 바꾸기",
  "トラックを削除": "트랙 삭제",
  "⌘Z で戻せます": "⌘Z로 되돌릴 수 있습니다",
  "歌のトラックは 1 本は残す必要があります（ピアノロールで使うため）": "보컬 트랙은 하나 이상 남겨야 합니다 (피아노 롤에서 사용)",
  "トラックを削除しました: {name}（⌘Z で戻せます）": "트랙을 삭제했습니다: {name} (⌘Z로 되돌리기)",
  "トラック {n}": "트랙 {n}",
  "読み込み中: {name}": "불러오는 중: {name}",
  "音声ファイルを読めませんでした: {name}（{e}）": "오디오 파일을 읽을 수 없습니다: {name} ({e})",
  "伴奏トラックを追加しました: {name}（{sec} 秒）": "반주 트랙을 추가했습니다: {name} ({sec}초)",
  "クリック・ドラッグ: 再生位置を移動": "클릭·드래그: 재생 위치 이동",
  "ドラッグ: 左右に移動　⌘/Ctrl+ホイール・ピンチ: 時間方向の拡大縮小": "드래그: 좌우 이동　⌘/Ctrl+휠·핀치: 시간축 확대/축소",
  "ドラッグ: 伴奏を移動（スナップしない）　右クリック: 名前を変える・削除": "드래그: 반주 이동 (스냅 없음)　우클릭: 이름 바꾸기·삭제",
  "ドラッグ: トラックを移動（音符とパラメータの曲線も一緒に）　⌥+ドラッグ: スナップしない　右クリック: 名前を変える・削除": "드래그: 트랙 이동 (음표와 파라미터 곡선도 함께)　⌥+드래그: 스냅 없음　우클릭: 이름 바꾸기·삭제",
  "ドラッグ: 伴奏の再生範囲を詰める・戻す（スナップしない）": "드래그: 반주 재생 범위 자르기·복원 (스냅 없음)",
  "ドラッグ: トラックの範囲を変更（範囲の外の音符は歌わない）　⌥+ドラッグ: スナップしない": "드래그: 트랙 범위 변경 (범위 밖 음표는 부르지 않음)　⌥+드래그: 스냅 없음",
  "クリック・ドラッグ: ピアノロールの表示位置を移動　ホイール: 上下　Shift+ホイール: 左右　⌘/Ctrl+ホイール・ピンチ: 拡大縮小　音声ファイルをドロップ: 伴奏トラックを追加": "클릭·드래그: 피아노 롤 보기 위치 이동　휠: 상하　Shift+휠: 좌우　⌘/Ctrl+휠·핀치: 확대/축소　오디오 파일 끌어다 놓기: 반주 트랙 추가",
  "ダブルクリック: 名前を変える": "더블클릭: 이름 바꾸기",
  "音量": "볼륨",
  "パン": "팬",
  "中央": "센터",
  "左": "좌",
  "右": "우",
  "ミュート": "뮤트",
  "ソロ": "솔로",
  "ドラッグ: 音素の境界を移動（休符の後の先頭は前の休符の中まで伸ばせます。フレーズの終わりは動きません）　ダブルクリック: 元に戻す": "드래그: 음소 경계 이동 (쉼표 뒤의 시작은 그 쉼표 안까지 늘릴 수 있음, 프레이즈 끝은 고정)　더블클릭: 되돌리기",
  "音素": "음소",
  "波形": "파형",
  "ドラッグで高さを変える": "드래그하여 높이 변경",
  "閉じる（Esc）": "닫기 (Esc)",
  "書き出し": "내보내기",
  "ファイル名": "파일 이름",
  "形式": "형식",
  "チャンネル": "채널",
  "ステレオ": "스테레오",
  "モノ（パンは掛けない）": "모노 (팬 적용 안 함)",
  "ビット深度": "비트 깊이",
  "32 bit 浮動小数": "32비트 부동소수점",
  "無題": "제목 없음",
  "ミックスを書き出す": "믹스 내보내기",
  "再生と同じ音（ミュート・ソロ、トラックの音量とパン、エフェクターを反映）": "재생과 같은 소리 (뮤트·솔로, 트랙 볼륨과 팬, 이펙터 반영)",
  "トラックを別々に書き出す": "트랙을 따로 내보내기",
  "選んだトラックを書き出す（{n} ファイル）": "선택한 트랙 내보내기 (파일 {n}개)",
  "書き出し中…": "내보내는 중…",
  "レンダリング中（残り {n} フレーズ）": "합성 중 (남은 프레이즈 {n}개)",
  "エンジンにつながっていないので書き出せません。": "엔진에 연결되지 않아 내보낼 수 없습니다.",
  "連続音の歌詞 {n} 個を単独音に直しました": "연속음 가사 {n}개를 단독음으로 바꿨습니다",
  "ブレスの記号 {n} 個を休符にしました": "숨 기호 {n}개를 쉼표로 바꿨습니다",
  "読めない歌詞 {n} 個を休符にしました: {list}": "읽을 수 없는 가사 {n}개를 쉼표로 바꿨습니다: {list}",
  "ブレスを {n} 個入れました": "숨을 {n}개 넣었습니다",
  "書き出しました: {names}": "내보냈습니다: {names}",
  "書き出しに失敗しました: {e}": "내보내기에 실패했습니다: {e}",
  "設定": "설정",
  "画面の言語": "화면 언어",
  "変更するとページを再読み込みします（編集内容は自動保存から復元されます）": "변경하면 화면을 다시 불러옵니다 (편집 내용은 자동 저장에서 이어집니다)",
  "アクセントカラー": "강조색",
  "音符・選んだ所・つまみの色。トラックの色もここから作ります": "음표·선택 영역·컨트롤의 색. 트랙 색도 여기서 만들어집니다",
  "好きな色を選ぶ": "원하는 색 선택",
  "自由選択": "사용자 지정",
  "既定に戻す": "기본값으로",
  "mel の配色": "mel 색상표",
  "下のパネルの mel の色": "아래 패널의 mel 색",
  "エンジン": "엔진",
  "GPU で計算する（実験的・Chrome 向け。変更は読み込み直しで反映）": "GPU로 계산 (실험적, Chrome용. 변경은 다시 불러오면 적용)",
  "Safari では使えません（WebGPU 入りの部品を読むとページが読み込み直されるため）": "Safari에서는 사용할 수 없습니다 (WebGPU 포함 구성 요소를 불러오면 페이지가 다시 로드되기 때문)",
  "このブラウザは WebGPU に対応していません": "이 브라우저는 WebGPU를 지원하지 않습니다",
  "この環境では GPU を使えません（WebGPU の準備ができません）": "이 환경에서는 GPU를 사용할 수 없습니다 (WebGPU를 준비할 수 없음)",
  "VocaTab のプロジェクト": "VocaTab 프로젝트",
  "（未保存）": " (저장 안 됨)",
  "編集はブラウザの中に自動で保存しています（読み込み直しても続きから）": "편집 내용은 브라우저에 자동 저장됩니다 (다시 불러와도 이어서 작업)",
  "自動保存 {time}": "자동 저장 {time}",
  "自動保存に失敗: {e}": "자동 저장 실패: {e}",
  "新規": "새로 만들기",
  "サンプル曲から始める": "예제 곡으로 시작",
  "開く": "열기",
  "⌘O　.svsproj か、音声も含めた .zip": "⌘O　.svsproj 또는 오디오를 포함한 .zip",
  "保存": "저장",
  "名前を付けて保存": "다른 이름으로 저장",
  "音声も含めて書き出す": "오디오 포함 내보내기",
  "伴奏の音声もまとめた .zip": "반주 오디오까지 담은 .zip",
  "楽譜を読み込む": "악보 불러오기",
  "MusicXML（.musicxml・.xml・.mxl）・UST。新しい歌のトラックにする": "MusicXML(.musicxml, .xml, .mxl)·UST. 새 보컬 트랙으로 추가",
  "今のプロジェクトを閉じて、サンプル曲から始めますか？（保存していない変更は消えます）": "현재 프로젝트를 닫고 예제 곡으로 시작할까요? (저장하지 않은 변경 사항은 사라집니다)",
  "新しいプロジェクトにしました": "새 프로젝트를 만들었습니다",
  "音声も含めたプロジェクト": "오디오를 포함한 프로젝트",
  "開きました: {name}": "열었습니다: {name}",
  "開けませんでした: {name}": "열 수 없습니다: {name}",
  "伴奏の音声が見つかりません": "반주 오디오를 찾을 수 없습니다",
  "プロジェクトファイルには伴奏の音声は含まれていません。元の音声ファイルを選択してください（複数選択可。内容で照合するため、移動や名前変更があっても問題ありません）。": "프로젝트 파일에는 반주 오디오 자체가 들어 있지 않습니다. 원본 오디오 파일을 선택하세요 (여러 개를 한꺼번에 선택할 수 있습니다. 내용의 지문으로 대조하므로 파일 위치나 이름이 바뀌어도 괜찮습니다).",
  "ファイルを選ぶ": "파일 선택",
  "あとで（音を出さずに続ける）": "나중에 (소리 없이 계속)",
  "伴奏を再リンクしました: {names}": "반주를 다시 연결했습니다: {names}",
  "リンクしました: {names}": "연결했습니다: {names}",
  "一致するファイルが見つかりませんでした: {names}": "맞는 파일이 없습니다: {names}",
  "楽譜を読めませんでした: {name}": "악보를 읽을 수 없습니다: {name}",
  "楽譜を読み込みました: {name}（{tracks} トラック、{notes} 音符、テンポ {bpm}）": "악보를 불러왔습니다: {name} (트랙 {tracks}개, 음표 {notes}개, 템포 {bpm})",
  "　注意: {w}": "　주의: {w}",
  "保存しました": "저장했습니다",
  "保存しました: {name}": "저장했습니다: {name}",
  "保存できませんでした: {e}": "저장할 수 없습니다: {e}",
  "ダウンロードしました": "다운로드했습니다",
  "音声も含めて書き出しました: {name}（{mb} MB）": "오디오 포함 내보냈습니다: {name} ({mb} MB)",
  "ルーム": "룸",
  "ホール": "홀",
  "プレート": "플레이트",
  "アリーナ": "아레나",
  "オン/オフ": "켜기/끄기",
  "イコライザー": "이퀄라이저",
  "ローカット": "로우컷",
  "周波数": "주파수",
  "ゲイン": "게인",
  "幅（Q）": "폭 (Q)",
  "空いている所をダブルクリックでポイントを追加。ドラッグで移動、ポイントの上でホイールを回すと幅（Q）を調整、右クリックまたは Delete で削除します。⌐ はローカットです。":
    "빈 곳을 더블클릭해 포인트 추가. 드래그로 이동, 포인트 위에서 휠로 폭(Q) 조정, 우클릭이나 Delete로 삭제. ⌐는 로우컷.",
  "濁り": "탁함",
  "こもり": "답답함",
  "鼻": "콧소리",
  "抜け": "존재감",
  "歯擦音": "치찰음",
  "空気": "공기감",
  "合成が完了すると、ここに声のスペクトルが表示されます": "합성이 끝나면 여기에 목소리 스펙트럼이 표시됩니다",
  "幅 {q}": "폭 {q}",
  "ローカット: {f}": "로우컷: {f}",
  "ポイントは {n} 個まで追加できます": "포인트는 {n}개까지 추가할 수 있습니다",
  "このポイントを削除": "이 포인트 삭제",
  "コンプレッサー": "컴프레서",
  "スレッショルド {db} dB": "스레숄드 {db} dB",
  "スレッショルド": "스레숄드",
  "アタック": "어택",
  "レシオ": "비율",
  "リバーブ": "리버브",
  "始まり": "시작",
  "量": "양",
  "長さ": "길이",
  "長さ {d} 秒 · 量 {w} % · 始まり {p} ms": "길이 {d}초 · 양 {w} % · 시작 {p} ms",
  "ポイントをドラッグして、プリディレイ・ミックス量・残響の長さを調整します。ダブルクリックで種類の値に戻ります。": "점을 드래그해 프리딜레이, 믹스 양, 잔향 길이를 조정합니다. 더블클릭하면 종류의 값으로 돌아갑니다.",
  "{name}: {value}（上下にドラッグで回す、⇧ で細かく、ダブルクリックで戻す）": "{name}: {value} (위아래로 드래그, ⇧ 미세 조정, 더블클릭으로 초기화)",
  "Space: 再生・一時停止　1: 選択　2: 鉛筆　3: ピッチのペン　Delete: 削除　⌘C / ⌘V: コピー / 再生位置に貼り付け　⌘Z / ⇧⌘Z: 取り消し / やり直し　↑↓: 半音（⇧ でオクターブ）": "Space: 재생·일시정지　1: 선택　2: 연필　3: 피치 펜　Delete: 삭제　⌘C / ⌘V: 복사 / 재생 위치에 붙여넣기　⌘Z / ⇧⌘Z: 실행 취소 / 다시 실행　↑↓: 반음 (⇧ 옥타브)",
  "{n} 個の音符をコピーしました": "음표 {n}개를 복사했습니다",
  "{n} 個の音符を切り取りました": "음표 {n}개를 잘라냈습니다",
  "{n} 個の音符を再生位置に貼り付けました": "음표 {n}개를 재생 위치에 붙여넣었습니다",
  "コピーする音符を選んでください": "먼저 복사할 음표를 선택하세요",
  "貼り付ける音符がありません（先に ⌘C でコピー）": "붙여넣을 음표가 없습니다 (먼저 ⌘C로 복사)",
  "パラメータ": "파라미터",
  "音素のタイミング": "음소 타이밍",
  "実験版": "실험판",
  "モック": "목업",
  "エンジン未接続（モック）": "엔진 미연결 (목업)",
  "レンダリング中 {done}/{all} フレーズ": "합성 중 {done}/{all} 프레이즈",
  "レンダリング完了": "합성 완료",
  "レンダリング完了（待機中）": "합성 완료 (엔진 대기 중)",
  "モデルを読み込み中 {p}%（{mb} / {total} MB）": "모델 불러오는 중 {p}% ({mb} / {total} MB)",
  "選択 (1)": "선택 (1)",
  "音符を描く (2)": "음표 그리기 (2)",
  "ピッチのペン (3)": "피치 펜 (3)",
  "ピッチの線": "피치 선",
  "再生・一時停止（Space）": "재생·일시정지 (Space)",
  "テンポは 20〜400 の数で入れてください（{s}）": "템포는 20~400 사이의 숫자로 입력하세요 ({s})",
  "拍子は「3」「6/4」のように、4 分音符を 1 拍として入れてください（{s}）": "박자는 \"3\", \"6/4\"처럼 4분음표를 1박으로 입력하세요 ({s})",
  "1 小節の拍の数は 1〜16 です": "한 마디의 박 수는 1~16입니다",
  "前回の続きから開きました（{at} に自動保存）": "지난 작업에서 이어서 열었습니다 ({at} 자동 저장)",
  "自動保存を読めませんでした: {e}": "자동 저장을 읽을 수 없습니다: {e}",
  "計算中…（フレーズの合成が終わると表示されます）": "계산 중… (엔진이 프레이즈를 합성하면 표시됩니다)",
  "{sec} s（{fr} フレーム）　{hz} Hz（bin {bin}）　{val}": "{sec} s ({fr} 프레임)　{hz} Hz (bin {bin})　{val}",
  "① ボコーダに入れる mel（postfilter 後）": "① 보코더에 넣는 mel (postfilter 이후)",
  "② ボコーダの出力の mel（声の調整なし）": "② 보코더 출력의 mel (음성 조정 없음)",
  "③ 声の調整を掛けた音の mel": "③ 음성 조정을 적용한 소리의 mel",
  "ボコーダの入力": "보코더 입력",
  "ボコーダの出力": "보코더 출력",
  "声の調整後": "음성 조정 후",
  "エンジンの mel。② は声の調整を掛けない音（②③ はオンのときだけ作る）": "엔진의 mel. ②는 음성 조정을 적용하지 않은 소리 (②③는 켜져 있을 때만 생성)",
  "仮のデータです（エンジン未接続）。オフの行は計算しません": "임시 데이터 (엔진 미연결). 꺼진 행은 계산하지 않음",
  "（伸ばし）": "(늘임)",
  "{n} 個": "{n}개",
  "{ph} · {pitch} · {beats} 拍": "{ph} · {pitch} · {beats}박",
  "{lyric} ほか（まとめて変える）": "{lyric} 외 (함께 변경)",
  "抑揚": "억양",
  "AI が付けた抑揚（しゃくり・こぶし・音の移り方など、音符の高さからのずれ）の倍率（0 で音符の高さどおり）。ダブルクリックで 1 に戻す":
    "AI가 붙인 억양(스쿱, 꺾기, 음 사이의 이동 등 음표 높이에서 벗어난 정도)의 배율 (0이면 음표 높이 그대로). 더블클릭으로 1로 되돌리기",
  "ビブラート": "비브라토",
  "AI が付けたビブラートの幅の倍率（0 で消える）。ダブルクリックで 1 に戻す": "AI가 붙인 비브라토 폭의 배율 (0이면 사라짐). 더블클릭으로 1로 되돌리기",
  "ピッチ": "피치",
  "抑揚とビブラートを取り直す": "억양과 비브라토를 다시 생성",
  "声": "음색",
  "息づかいや音色の細部を取り直す": "숨결과 음색의 세부를 다시 생성",
  "最初のテイク": "첫 테이크",
  "{n} 回目": "{n}번째",
  "{n} 個をリテイクしました": "{n}개 다시 생성됨",
  "この音符だけ AI の生成をやり直す": "이 음표만 AI 생성을 다시 하기",
  "リテイク": "다시 생성",
  "一つ前のテイクに戻す": "이전 테이크로 되돌리기",
  "一つ前": "이전",
  "最初のテイク（初期の乱数）に戻す": "첫 테이크(초기 난수)로 되돌리기",
  "最初": "처음",
  "ピッチのずれ": "피치 편차",
  "抑揚の強さ": "억양 강도",
  "ビブラートの強さ": "비브라토 강도",
  "テンション": "긴장감",
  "張る": "긴장",
  "緩む": "이완",
  "ブレシネス": "숨소리",
  "息が多い": "숨 많음",
  "息が少ない": "숨 적음",
  "ジェンダー": "포먼트",
  "男性的": "굵게",
  "女性的": "밝게",
  "有声度": "유성음 정도",
  "有声": "유성",
  "無声": "무성",
  "子音の強さ": "자음 강도",
  "強い": "강함",
  "弱い": "약함",
  "響き": "울림",
  "響く": "울림 많음",
  "こもる": "먹먹함",
  "うなり": "그로울",
  "なし": "없음",
  "表示/非表示": "표시·숨기기",
  "クリックで前面に表示（編集できるのは最前面の曲線）": "클릭: 맨 앞으로 (그리기는 맨 앞 곡선에)",
  "パラメータを選び直す": "파라미터 변경",
  "この曲線を閉じる": "이 곡선 닫기",
  "曲線を追加": "곡선 추가",
  "鉛筆": "연필",
  "直線": "직선",
  "消しゴム（右ドラッグでも消せる）": "지우개 (우클릭 드래그로도 지울 수 있음)",
  "ドラッグ: 最前面の曲線を描く　右ドラッグ: 消去（初期値に戻す）　タブ名をクリックで前面に表示": "드래그: 맨 앞 곡선 그리기　우클릭 드래그: 지우기 (기본값으로)　탭 이름을 누르면 맨 앞으로",
  "NSF-HiFiGAN では効きません": "NSF-HiFiGAN에서는 효과 없음",
  "ドラッグ: ピッチの線を描く（ピッチのずれに書き込む）　右ドラッグ: 消去して元に戻す": "드래그: 피치 선 그리기 (피치 편차에 기록)　우클릭 드래그: 지워서 원래대로",
  "ドラッグ: トラックの範囲を変更（範囲の外の音符は歌わない、端をまたぐ音符は端で切れる）　⌥: スナップしない": "드래그: 트랙 범위 변경 (범위 밖 음표는 부르지 않고, 경계에 걸친 음표는 경계에서 잘림)　⌥: 스냅 없음",
  "ドラッグ: 長さを変更": "드래그: 길이 변경",
  "ドラッグ: 移動（Shift で選択に追加）　ダブルクリック: 歌詞を入力": "드래그: 이동 (Shift로 선택에 추가)　더블클릭: 가사 입력",
  "ドラッグ: 音符を描く": "드래그: 음표 그리기",
  "ドラッグ: 範囲選択　ホイール: 上下　Shift+ホイール: 左右　⌘+ホイール: 横の拡大　⌥+ホイール: 縦の拡大": "드래그: 범위 선택　휠: 상하　Shift+휠: 좌우　⌘+휠: 가로 확대　⌥+휠: 세로 확대",
  "プロジェクトのファイルとして読めません（JSON ではない）": "프로젝트 파일로 읽을 수 없습니다 (JSON이 아님)",
  "この SVS のプロジェクトのファイルではありません": "이 SVS의 프로젝트 파일이 아닙니다",
  "新しいバージョン（{v}）で保存されたファイルです。アプリを更新してください": "새 버전({v})으로 저장된 파일입니다. 앱을 업데이트하세요",
  "歌のトラックがありません": "보컬 트랙이 없습니다",
  "（中身が保存したときと違います）": " (저장 당시와 내용이 다릅니다)",
  "zip として読めません": "zip으로 읽을 수 없습니다",
  "zip の目次が壊れています": "zip 목차가 손상되었습니다",
  "圧縮された zip には対応していません（{name}）": "압축된 zip은 지원하지 않습니다 ({name})",
  "zip の中に project.svsproj がありません": "zip 안에 project.svsproj가 없습니다",
  "解析に失敗: {e}": "분석 실패: {e}",
  "合成に失敗: {e}": "합성 실패: {e}",
  "エンジンとの通信に失敗: {e}": "엔진과 통신 실패: {e}",
  "メロディ": "멜로디",
  "MusicXML として読めません（XML が壊れています）": "MusicXML로 읽을 수 없습니다 (XML 손상)",
  "<part> がありません": "<part>가 없습니다",
  "{all} パートのうち、歌詞のある {n} パートを読みました": "{all}개 파트 중 가사가 있는 {n}개 파트를 읽었습니다",
  "声部が {n} つあります（未対応）。全部つなげて読むので譜面と違う音になります": "성부가 {n}개 있습니다 (미지원). 모두 이어서 읽으므로 악보와 다른 소리가 됩니다",
  "<backup>/<forward> があります（未対応）。時刻がずれます": "<backup>/<forward>가 있습니다 (미지원). 시간이 어긋납니다",
  "繰り返し記号があります（未対応）。展開せず、書かれた順に 1 回だけ歌います": "반복 기호가 있습니다 (미지원). 펼치지 않고 적힌 순서대로 한 번만 부릅니다",
  "divisions が途中で変わります（未対応）。最初の値を使います": "divisions가 중간에 바뀝니다 (미지원). 처음 값을 사용합니다",
  "テンポが途中で変わります（未対応）。最初の値 {bpm} を使います": "템포가 중간에 바뀝니다 (미지원). 처음 값 {bpm}을 사용합니다",
  "テンポの指定がありません。120 とみなします": "템포 지정이 없습니다. 120으로 간주합니다",
  ".mxl の中に楽譜の XML が見つかりません": ".mxl 안에서 악보 XML을 찾을 수 없습니다",
  "読める楽譜は UST と MusicXML（.musicxml・.xml・.mxl）です: {name}": "읽을 수 있는 악보는 UST와 MusicXML(.musicxml, .xml, .mxl)입니다: {name}",
  "歌い手と声": "가수와 음성",
  "エフェクター": "이펙트",
  "レンダリング": "합성 상태",
  "{n} つ有効": "{n}개 켜짐",
  "エンジン未接続": "엔진 미연결",
  "{done}/{all} フレーズ": "{done}/{all} 프레이즈",
  "完了": "완료",
  "歌い手": "가수",
  "モデル": "모델",
  "日本語": "일본어",
  "韓国語": "한국어",
  "「{name}」を鳴らせません: {e}": "“{name}”을(를) 재생할 수 없습니다: {e}",
  "「{name}」のエフェクトを掛けられません: {e}": "“{name}”에 이펙트를 적용할 수 없습니다: {e}",
  "{sec} 秒からのフレーズに不正な値が {n} 個ありました（無音に置き換えて再生します）": "{sec}초부터의 프레이즈에 잘못된 값이 {n}개 있었습니다 (무음으로 바꿔 재생합니다)",
  "ボコーダ": "보코더",
  "NSF-HiFiGAN は調波・雑音の分岐を持たないため、音量とうなり以外は効きません。": "NSF-HiFiGAN에는 하모닉·노이즈 분기가 없어 볼륨과 그로울 외에는 효과가 없습니다.",
  "声の調整": "음성 조정",
  "ダブルクリックで元に戻す": "더블클릭으로 초기화",
  "解析完了": "분석 완료",
  "合成中": "합성 중",
  "失敗": "실패",
  "フレーズ {i}": "프레이즈 {i}",
  "エンジンは未接続です（モック）。フレーズごとの計算の状況がここに並びます。": "엔진이 연결되지 않았습니다 (목업). 프레이즈별 계산 상황이 여기에 표시됩니다.",
  "未計算": "미계산",
  "藤": "등나무",
  "夜桜": "밤벚꽃",
  "氷": "얼음",
  "墨": "먹",
  "設定（言語・アクセントカラー・mel の配色）": "설정 (언어·강조색·mel 색상표)",
  "ファイル ▾": "파일 ▾",
  "トラック": "트랙",
  "トラックを追加（歌・伴奏）": "트랙 추가 (보컬·반주)",
  "スナップ": "스냅",
  "スナップ 自動": "스냅 자동",
  "1 小節": "1마디",
  "1/8 の 3 連": "1/8 셋잇단",
  "スナップなし": "스냅 없음",
  "WAV に書き出す": "WAV로 내보내기",
  "上下にドラッグ: トラック一覧の高さを変更（ダブルクリック: 全トラックが収まる高さ）": "위아래로 드래그: 트랙 목록의 높이 변경 (더블클릭: 모든 트랙이 보이는 높이)",
  "再生": "재생",
  "サイドバーの表示/非表示": "사이드바 표시 / 숨기기",
  "停止して先頭に戻る": "정지하고 처음으로",
  "ループ（今後対応予定）": "반복 (추후 구현)",
  "クリック: テンポを変更": "클릭: 템포 변경",
  "クリック: 拍子を変更": "클릭: 박자 변경",
  "再生位置を追う": "재생 위치 따라가기",
  "クリック: ここにブレスを入れる": "클릭: 여기에 브레스 넣기",
  "クリック: 別のブレスに替える　右クリック: 消す": "클릭: 다른 브레스로 바꾸기　우클릭: 삭제",
  "ブレス": "브레스",
  "すべてに入れる": "모두 넣기",
  "すべて消す": "모두 삭제",
  "ブレスの合成に失敗: {e}": "브레스 합성 실패: {e}",
  "この歌い手にはブレスの素材がありません。": "이 가수에게는 브레스 소재가 없습니다.",
  "音素のタイミングの「+ br」をクリックしても 1 つずつ入れられます（直前の音符から 0.1 秒以上空いた音符の前）。": "음소 타이밍 패널의 “+ br”을 클릭해 하나씩 넣을 수도 있습니다 (앞 음표에서 0.1초 이상 떨어진 음표 앞).",
};
